/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagedList } from '../../models/paged-list';
import { ProjectDto } from '../../models/project-dto';

export interface ProjectsFindAll$Params {
  name?: string;
  is_active?: boolean;
  limit?: number;
  start?: number;
  order?: string;
  dir?: number;
}

export function projectsFindAll(http: HttpClient, rootUrl: string, params?: ProjectsFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedList & {
'items'?: Array<ProjectDto>;
}>> {
  const rb = new RequestBuilder(rootUrl, projectsFindAll.PATH, 'get');
  if (params) {
    rb.query('name', params.name, {});
    rb.query('is_active', params.is_active, {});
    rb.query('limit', params.limit, {});
    rb.query('start', params.start, {});
    rb.query('order', params.order, {});
    rb.query('dir', params.dir, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedList & {
      'items'?: Array<ProjectDto>;
      }>;
    })
  );
}

projectsFindAll.PATH = '/projects';
